import { AuthService } from '@/utils/service'

export const getAvaliableCoupons = (page) => {
    page = page || 0;
    return new AuthService({
        url: '/api/coupon/list',
        method: 'get',
        data: {
            page: page,
            type: 1
        }
    })
}

export const getInvalidCoupons = (page) => {
    page = page || 0;
    return new AuthService({
        url: '/api/coupon/list',
        method: 'get',
        data: {
            page: page,
            type: 0
        }
    })
}

export const getCoupon = (couponId) => {
    return new AuthService({
        url: '/api/coupon/' + couponId,
        method: 'get'
    })
}

export const consume = (couponId) => {
    return new AuthService({
        url: '/api/coupon/' + couponId,
        method: 'post'
    })
}

export const bankCardState = () => {
    return new AuthService({
        url: '/api/coupon/bankcard/state',
        method: 'get'
    })
}

export const couponLast = () => {
    return new AuthService({
        url: '/api/coupon/last',
        method: 'get'
    })
}

export default {
    getAvaliableCoupons,
    getInvalidCoupons,
    getCoupon,
    consume,
    bankCardState,
    couponLast,
}